import { render, staticRenderFns } from "./save-paper-info.html?vue&type=template&id=cb6836d0&scoped=true&"
import script from "./save-paper-info.js?vue&type=script&lang=js&"
export * from "./save-paper-info.js?vue&type=script&lang=js&"
import style0 from "./save-paper-info.scss?vue&type=style&index=0&id=cb6836d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb6836d0",
  null
  
)

export default component.exports